import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  // Private properties
  private el: ElementRef;
  private stopped: boolean;

  /**
   * Init
   *
   * @param element: ElementRef
   */
  init(element: ElementRef) {
    this.el = element;
  }

  /**
   * Hide
   */
  hide() {
    if (this.stopped || !this.el) {
      return;
    }

    const element = this.el.nativeElement as HTMLElement;
    const removeElement = () => {
      if (typeof element.remove === 'function') {
        element.remove();
      } else {
        element.style.display = 'none';
      }
      this.stopped = true;
    };

    setTimeout(() => {
      if (typeof element.animate !== 'function') {
        element.style.opacity = '0';
        removeElement();
        return;
      }

      const animation = element.animate([{ opacity: '1' }, { opacity: '0' }], {
        duration: 800,
        fill: 'forwards',
      });

      animation.finished.then(removeElement).catch(removeElement);
    }, 100);
  }
}
